export default __webpack_public_path__ + "images/0e4ef2b87ec6f83431356ffdc8ec573d-emoji-bloated.svg";